<template>
  <svg :width="width" :height="height" :viewbox="viewbox" v-html="gauge"></svg>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'credit-gauge',
  props: ['size', 'score'],
  data: () => ({}),
  computed: {
    gauge() {
      if (_.isUndefined(this.score)) {
        return null;
      }

      return this.creditScoreGauge(this.score, this.size).outerHTML;
    },
    width() {
      return this.size;
    },
    height() {
      return this.size * 0.855;
    },
    viewbox() {
      return '0 0 ' + this.width + ' ' + this.height;
    }
  },
  methods: {
    calculateArc(size, segment, colour, active) {
      let arcSize = size * 0.8;
      let strokeSize = active ? arcSize * 0.175 : arcSize * 0.11;
      let offset = size * 0.1;
      let svgns = 'http://www.w3.org/2000/svg';
      let path = document.createElementNS(svgns, 'path');
      let unit = (Math.PI * 2) / 100;

      let startangle = 12.5 * segment * unit;
      let endangle = (12.5 * segment + 12.5) * unit;

      let x1 = arcSize / 2 + (arcSize / 2) * Math.sin(startangle) + offset;
      let y1 = arcSize / 2 - (arcSize / 2) * Math.cos(startangle) + offset;
      let x2 = arcSize / 2 + (arcSize / 2) * Math.sin(endangle) + offset;
      let y2 = arcSize / 2 - (arcSize / 2) * Math.cos(endangle) + offset;

      let big = endangle - startangle > Math.PI ? 1 : 0;

      let d =
        'M ' +
        x1 +
        ',' +
        y1 + // Draw line to (x1,y1)
        ' A ' +
        arcSize / 2 +
        ',' +
        arcSize / 2 + // Draw an arc of radius r
        ' 0 ' +
        big +
        ' 1 ' + // Arc details...
        x2 +
        ',' +
        y2; // Arc goes to to (x2,y2)

      path.setAttribute('d', d); // Set this path
      path.setAttribute('fill', 'transparent');
      path.setAttribute('stroke-width', strokeSize);
      path.setAttribute('stroke', colour);

      if (active) {
        path.setAttribute('filter', 'url(#filterShadow)');
      }

      return path;
    },

    createTextElement(size, word, yPos) {
      let centre = (size * 0.85) / 2 + size * 0.075;
      let svgns = 'http://www.w3.org/2000/svg';
      let text = document.createElementNS(svgns, 'text');
      text.setAttribute('x', centre);
      text.setAttribute('y', centre + (size / 16) * (yPos + 1));
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('fill', '#595959');
      let style = 'font-weight: bold; font-size: ' + size / 16 + 'px;';
      text.setAttribute('style', style);
      text.textContent = word;

      return text;
    },

    creditScoreGauge(score, size) {
      let warningText, segment, path;
      let svgns = 'http://www.w3.org/2000/svg';
      let chart = document.createElement('g');

      // defs elements contains filter
      let defsElement = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
      let filterElement = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
      filterElement.setAttribute('id', 'filterShadow');
      filterElement.setAttribute('x', '-100%');
      filterElement.setAttribute('y', '-90%');
      filterElement.setAttribute('width', '400%');
      filterElement.setAttribute('height', '400%');

      // offset is the element we're going to use to create the dropshadow. some we want drop shadow directly underneath element offset is 0,0
      let feOffset = document.createElementNS('http://www.w3.org/2000/svg', 'feOffset');
      feOffset.setAttribute('result', 'offOut');
      feOffset.setAttribute('in', 'SourceAlpha');
      feOffset.setAttribute('dx', '0');
      feOffset.setAttribute('dy', '0');

      // now we blur the 'result'
      let feGaussianBlur = document.createElementNS('http://www.w3.org/2000/svg', 'feGaussianBlur');
      feGaussianBlur.setAttribute('result', 'blurOut');
      feGaussianBlur.setAttribute('in', 'offOut');
      feGaussianBlur.setAttribute('stdDeviation', '3');

      let feBlend = document.createElementNS('http://www.w3.org/2000/svg', 'feBlend');
      feBlend.setAttribute('in', 'SourceGraphic');
      feBlend.setAttribute('in2', 'blurOut');
      feBlend.setAttribute('mode', 'normal');

      filterElement.appendChild(feOffset);
      filterElement.appendChild(feGaussianBlur);
      filterElement.appendChild(feBlend);
      defsElement.appendChild(filterElement);
      chart.appendChild(defsElement);

      switch (true) {
        case score < 2:
          warningText = ['Exceeds', 'Maximum', 'Risk'];
          segment = 1;
          break;
        case score < 16:
          warningText = ['Maximum Risk'];
          segment = 1;
          break;
        case score < 26:
          warningText = ['High Risk'];
          segment = 2;
          break;
        case score < 51:
          warningText = ['Above', 'Average', 'Risk'];
          segment = 3;
          break;
        case score < 81:
          warningText = ['Below', 'Average', 'Risk'];
          segment = 4;
          break;
        case score < 91:
          warningText = ['Low Risk'];
          segment = 5;
          break;
        default:
          warningText = ['Very Low Risk'];
          segment = 6;
          break;
      }

      let colours = ['#D71211', '#EA6700', '#F1B402', '#A3C102', '#5BBA04', '#059700'];

      for (let i = 0; i < 6; i++) {
        let k = i < 3 ? i + 5 : i - 3;
        path = this.calculateArc(size, k, colours[i]);
        chart.appendChild(path);
      }

      let targetSegment = segment < 4 ? segment + 4 : segment - 4;

      path = this.calculateArc(size, targetSegment, colours[segment - 1], true);
      chart.appendChild(path);

      let text = document.createElementNS(svgns, 'text');
      text.setAttribute('x', (size * 0.85) / 2 + size * 0.075);
      text.setAttribute('y', (size * 0.85) / 2 + size * 0.075);
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('fill', colours[segment - 1]);
      let style = 'font-size: ' + size / 3 + 'px;font-weight:bold';
      text.setAttribute('style', style);
      text.textContent = score;

      chart.appendChild(text);

      let yPos = 1;

      warningText.forEach(word => {
        let text = this.createTextElement(size, word, yPos);
        chart.appendChild(text);
        yPos++;
      });

      return chart;
    }
  }
};
</script>
